import { t } from 'i18next';
import { useLocation } from 'react-router-dom';

import { useEmbedding } from '../../components/embed-provider';
import { Separator } from '../../components/ui/separator';
import { notificationHooks } from '../routes/platform/notifications/hooks/notifictions-hooks';
import { PlatformDialog } from '../routes/platform/notifications/paltform-dialog';

import UsageLimitsButton from './usage-limits-button';

import { UserAvatar } from '@/components/ui/user-avatar';
import { CreateProjectDialog } from '@/features/projects/components/create-project-dialog';
import { ProjectSwitcher } from '@/features/projects/components/project-switcher';
// import { InviteUserDialog } from '@/features/team/component/invite-user-dialog';
import { TenantSwitcher } from '@/features/tenant/components/tenant-switcher';

export const Header = () => {
  const history = useLocation();
  const isInPlatformAdmin = history.pathname.startsWith('/platform');
  const { embedState } = useEmbedding();
  const messages = notificationHooks.useNotifications();

  return (
    !embedState.isEmbedded && (
      <div>
        <PlatformDialog messages={messages} />
        <div className="flex h-[60px] items-center">
          {isInPlatformAdmin ? (
            <span className="text-3xl font-bold px-4 py-2">
              {t('Platform Admin')}
            </span>
          ) : (
            <ProjectSwitcher />
          )}
          <CreateProjectDialog />

          <div className="grow"></div>
          <div className="flex items-center justify-center gap-4">
            {/* <InviteUserDialog /> */}
            <UsageLimitsButton />
            <TenantSwitcher />
            <UserAvatar />
          </div>
        </div>
        <Separator></Separator>
      </div>
    )
  );
};
